import indexSouthernEn from '../../layout/indexSouthernEn.vue';
const homeRouter = {
	path: '/',
	component: indexSouthernEn,
	redirect: '/',
	name: 'chinese',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		//南方研究主页

		{
			path: '/en',
			component: () => import('@/pages/chinese/views/southernStudiesEn'),
			name: 'en',
		},
		//南方研究文章详情页

		{
			path: '/detailsSouthernEn',
			component: () =>
				import('@/pages/chinese/views/detail/detailsSouthernEn'),
			name: 'detailsSouthernEn',
		},
		//南方研究中心报告列表页
		{
			path: '/en/reportList',
			component: () =>
				import('@/pages/chinese/views/southernStudiesEn/reportList'),
			name: 'reportListEn',
		},
		//南方研究中心近期活动列表页（与中文共用同一组件）
		{
			path: '/en/activityList',
			component: () =>
				import('@/pages/chinese/views/southernStudies/activityList'),
			name: 'activityListEn',
		},
	],
};

export default homeRouter;
